export const ModalIds = {
    PAYWALL: 'paywall',
    STUDY_OVERVIEW_VIDEO: 'study_overview_video',
    EXPERT_CALL_VIDEO: 'expert_calls_overview_video',
} as const;
